module.exports = __webpack_public_path__ + "static/media/blog4.5a3276b1.jpg";